import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePopup } from '../../contexts/PopupContext';
import { ProfilePlanSparklesIcon } from './ProfileActivityIcons';
import './AccountPlanWidget.css';

/**
 * Karta „typ konta” + zapowiedź Premium (CTA na przyszłość — na razie nieaktywne).
 */
const TYPE_LABEL_FALLBACK = {
  user: 'Standard account',
  organizator: 'Organizer account',
  moderator: 'Moderator account',
  admin: 'Administrator account',
};

function AccountPlanWidget({ userRole = 'user' }) {
  const { t } = useTranslation(['profile']);
  const { openPopup } = usePopup();

  const handleUpgradeClick = () => {
    openPopup('settings-billing', {}, 1);
  };

  const normalizedRole = ['organizator', 'moderator', 'admin'].includes(userRole)
    ? userRole
    : 'user';

  return (
    <aside className="apw-widget" aria-labelledby="apw-heading">
      <div className="apw-accent" aria-hidden />
      <div className="apw-inner">
        <header className="apw-header">
          <span className="apw-header-icon" aria-hidden>
            <ProfilePlanSparklesIcon size={20} />
          </span>
          <p id="apw-heading" className="apw-title">
            {t('profile.accountPlan.title', 'Twój plan')}
          </p>
        </header>

        <div className="apw-body">
          <p className={`apw-type apw-type--${normalizedRole}`}>
            {t(
              `profile.accountPlan.typeLabels.${normalizedRole}`,
              TYPE_LABEL_FALLBACK[normalizedRole]
            )}
          </p>
          <p className="apw-desc">
            {t(
              'profile.accountPlan.description',
              'To nie jest jeszcze konto Premium — w przyszłości odblokujesz dodatkowe funkcje i wyróżnienie profilu.'
            )}
          </p>
        </div>

        <div className="apw-footer">
          <button
            type="button"
            className="apw-cta"
            onClick={handleUpgradeClick}
          >
            {t('profile.accountPlan.cta', 'Ulepsz konto')}
            <span className="apw-cta-arrow" aria-hidden>›</span>
          </button>
        </div>
      </div>
    </aside>
  );
}

export default AccountPlanWidget;
